import { render } from "./Materials.vue?vue&type=template&id=2b3929de&scoped=true"
import script from "./Materials.vue?vue&type=script&lang=js"
export * from "./Materials.vue?vue&type=script&lang=js"

import "./Materials.vue?vue&type=style&index=0&id=2b3929de&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2b3929de"

export default script